import { WobType } from '@/enum/WobType';
import { IAloBaseArray } from '../alo/AloBaseArray';
import { v4 as uuidv4 } from 'uuid';

export class ConsoleRow {
    public date:Date
    public rowType:string
    public data:string
    public wobTrmId:number|string|null
    public global:boolean
    public cycle:string    
    public gdbType:string
    

    constructor({date = '', rowType='', data='',wobTrmId=null, cycle='', global = false,gdbType=''} = {}) {
        this.date = new Date(date)
        this.rowType = rowType
        this.data = data
        this.cycle = cycle
        this.wobTrmId = wobTrmId
        this.global = global        
        this.gdbType = gdbType
    }

    static createConsoleRow(wob:any) {
        switch(wob.wobType) {
            case WobType.WobGliderGdb:                    
                return new ConsoleRow({rowType: 'GLIDER', date:wob.wobDat, data: wob.gdbGliRaw,wobTrmId:wob?.wobTrmId ?? uuidv4(), cycle:wob.gliCycle,gdbType:wob.gdbType})
            case WobType.WobGliderIrisGdb:
                return new ConsoleRow({rowType: 'IRIS', date:wob.wobDat, data: wob.gdbIrisRaw,wobTrmId:wob?.wobTrmId ?? uuidv4(), cycle:wob.gliCycle, gdbType:wob.gdbType})
            /*case WobType.WobGliderSl:
                return new ConsoleRow({rowType: 'SL', date:wob.wobDat, data: wob.msgRaw,wobTrmId:wob.wobTrmId, cycle:wob.gliCycle})*/
            case WobType.WobIrisGdb :
                return new ConsoleRow({rowType: 'IRIS', date:wob.wobDat, data: wob.gdbIrisRaw,wobTrmId:wob?.wobTrmId ?? uuidv4(), global:true,gdbType:wob.gdbType})
            /*case WobType.WobSl :
                return new ConsoleRow({rowType: 'SL', date:wob.wobDat, data: wob.msgRaw,wobTrmId:wob.wobTrmId, global:true, cycle:wob.gliCycle})*/
        }
        return null
    }

    static createConsoleRowArray(wobArr:IAloBaseArray) {
        return wobArr.items.reduce((acc:Array<ConsoleRow>, value:any) => {
            const consoleRow = ConsoleRow.createConsoleRow(value)
            if(consoleRow != null) acc.push(consoleRow)
            return acc 
        },[] as Array<ConsoleRow>)
    }
} 